import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material";
import { MergedPatientData } from "./patientVisitData";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";
import "moment/locale/he";

//region [[ Styles ]]

const SendPatientEmailTableView = styled("div")({
  direction: "rtl",
  width: "calc(100% - 65px)",
  marginRight: "65px",
  flex: 1,
});

const TableRow = styled("div")({
  display: "flex",
  flexFlow: "row",
  alignItems: "center",
  position: "relative",
});

const TableCell = styled("div")({
  padding: "15px",
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "15px",
  margin: "3px",
  backgroundColor: "aliceblue",
  width: "calc(100% / 9)",
});

const SelectedCheckBoxContainer = styled(TableCell)({
  width: "30px",
  position: "absolute",
  right: "-30px",
});
const TitleCell = styled(TableCell)({
  backgroundColor: "#efefef",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SendPatientEmailTableProps {
  patients: MergedPatientData[];
  // List of selected ids
  selectedIds: string[];
  onIdSelectChange: (p: MergedPatientData, selected: boolean) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SendPatientEmailTable = ({
  ...props
}: SendPatientEmailTableProps) => {
  const [showCheckBoxFor, setShowCheckBoxFor] = useState<string>("");

  const setShowCheckbox = (id) => {
    setShowCheckBoxFor(id);
  };

  const setHideCheckbox = (id) => {
    setShowCheckBoxFor((old) => {
      if (old === id) return "";
      else return old;
    });
  };
  const showSelectedCheckboxFor = (id: string) =>
    !!props.selectedIds.length || showCheckBoxFor === id;

  moment.locale("he");

  return (
    <SendPatientEmailTableView role="table">
      <TableRow role="rowgroup">
        <TitleCell>#</TitleCell>
        <TitleCell>מס תור</TitleCell>
        <TitleCell>תז</TitleCell>
        <TitleCell>שם</TitleCell>
        <TitleCell>מין</TitleCell>
        <TitleCell>גיל</TitleCell>
        <TitleCell>תאריך התור</TitleCell>
        <TitleCell>טלפון</TitleCell>
        <TitleCell>אימייל</TitleCell>
        <TitleCell>לינק לשיחה</TitleCell>
      </TableRow>
      {props.patients
        .sort(
          (a, b) =>
            new Date(a.visitDateTime).getTime() -
            new Date(b.visitDateTime).getTime(),
        )
        .map((p, index) => (
          <TableRow
            key={p.id || index}
            onMouseEnter={() => setShowCheckbox(p.id)}
            onMouseLeave={() => setHideCheckbox(p.id)}
          >
            {showSelectedCheckboxFor(p.id) && (
              <SelectedCheckBoxContainer>
                <Checkbox
                  checked={props.selectedIds?.some((s) => s === p.id)}
                  onChange={(e) => props.onIdSelectChange(p, e.target.checked)}
                />
              </SelectedCheckBoxContainer>
            )}
            <TitleCell>{index}</TitleCell>
            <TableCell>{p.index}</TableCell>
            <TableCell>{p.id}</TableCell>
            <TableCell>
              {p.firstName} {p.lastName}
            </TableCell>
            <TableCell>{p.gender}</TableCell>
            <TableCell>{p?.age}</TableCell>
            <TableCell>
              {moment(p.visitDateTime).format("dddd, Do/MM/YYYY [בשעה] h:mm a")}{" "}
            </TableCell>
            <TableCell>{p.phoneNumber}</TableCell>
            <TableCell>{p.email}</TableCell>
            <PatientInfoTableActionsCell patient={p} />
          </TableRow>
        ))}
    </SendPatientEmailTableView>
  );
};

export const PatientInfoTableActionsCell = (props: {
  patient: MergedPatientData;
}) => (
  <TableCell>
    {props.patient.caseUrl ? (
      <a href={props.patient.caseUrl}>Open</a>
    ) : (
      "loading..."
    )}
  </TableCell>
);
